export default __webpack_public_path__ + "static/media/candy-stripes.d813e7e6.png";